import { Navigate, isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

import Alert, { AlertVariant } from '../alerts/Alert';
import Icon, { Icons } from '../icons/Icon';
import Button, { ButtonVariant } from '../buttons/Button';

function ErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();
  console.error(error);

  const getMessage = (error: unknown): string => {
    let message = 'An unknown problem has occurred.';
    if (isRouteErrorResponse(error)) {
      message = `${error.statusText}. ${error.error?.message}.`;
    } else if (error instanceof Error) {
      message = error.message;
    }
    return message;
  };

  // Route not found
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <Navigate to="/" />;
  }

  return (
    <div
      data-testid="page-error"
      className="flex h-screen flex-col items-center justify-center px-4 py-2"
    >
      <div className="max-w-2xl">
        <div className="mb-4 flex items-center">
          <Icon name={Icons.CloudBolt} className="mr-2 text-4xl md:text-6xl" />
          <div className="text-xl font-bold md:text-3xl">We seem to be experiencing a problem.</div>
        </div>
        <Alert className="mb-6" variant={AlertVariant.Error}>
          {getMessage(error)}
        </Alert>
        <Button
          title="Go back"
          onClick={() => navigate('/')}
          variant={ButtonVariant.Secondary}
          className="w-32"
        >
          Go Back
        </Button>
      </div>
    </div>
  );
}

export default ErrorPage;
